import React, { useCallback, useContext, useState, useEffect } from 'react'
import SettingHandler from '../../../Apihander/setting/settingHandler';
import SidebarContext from '../../../contexts/MyContext';
import { successToast } from '../../../utils/notificationUtils';
import { Icon } from "@iconify/react/dist/iconify.js";

const RecordingQuality = () => {
  const { selectedQuality, setSelectedQuality, user, setUser } = useContext(SidebarContext);
  const [loading, setLoading] = useState(false)
  const [initialQuality, setInitialQuality] = useState(selectedQuality); // Initial state from the context

  // Set initial format when the component mounts or the user changes
  useEffect(() => {
    setInitialQuality(user?.selectedFormat);
    setSelectedQuality(user?.audioQuality);
    // return () => {
    // };
  }, [user]);



  const handleQualityChange = (value, event) => {
    setSelectedQuality(value)

  };

  const handleQualityUpdate = async (e) => {
    e.preventDefault()

    // Prevent API call if the selected quality is the same as the user's current audio quality
    if (user?.audioQuality === selectedQuality) {
      return;
    }
    setLoading(true)
    try {
      const payload = {
        audioQuality: selectedQuality
      }
      const Response = await SettingHandler.doHandlerSetting(payload)
      successToast(Response?.message || "Audio quality updated successfully")

      // Update user state and local storage with new quality
      const updatedUser = {
        ...user,
        audioQuality: selectedQuality,
      };
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));
      setUser(updatedUser);
      setInitialQuality(selectedQuality);

      setLoading(false)

    } catch (error) {
      console.log("🚀 ~ handleFormatChange ~ error:", error)
      setLoading(false)
    }
  };

  return (
    <div className='vr-set-page'>
      <h2 className="vr-set-title">
        Recording Quality
      </h2>
      <div className='vr-set-card'>
        <div className='vr-set-options'>
          <div className={`vr-set-option ${selectedQuality === "low" ? 'is-selected' : ''}`}
            role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
            onClick={(e) => handleQualityChange('low', e)}>
            <div className="form-check">
              <span className="vr-set-option-icon"><Icon icon="lucide:signal-low" width="18" height="18" /></span>
              <label className="form-check-label" htmlFor="lowRadio">
                <span className="vr-set-option-title">
                  Low
                  <p className="vr-set-option-desc">
                     Lower bitrate and space saver
                  </p>
                </span>
              </label>
              <input
                className="form-check-input"
                type="radio"
                name="audioQuality"
                id="lowRadio"
                value="low"
                checked={selectedQuality === "low"}
              />
            </div>
          </div>
          <div className={`vr-set-option ${selectedQuality === "medium" ? 'is-selected' : ''}`}
            role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
            onClick={(e) => handleQualityChange('medium', e)}>
            <div className="form-check">
              <span className="vr-set-option-icon"><Icon icon="lucide:signal-medium" width="18" height="18" /></span>
              <label className="form-check-label" htmlFor="mediumRadio">
                <span className="vr-set-option-title">
                  Medium
                  <p className="vr-set-option-desc">
                    Balanced quality and bitrate
                  </p>
                </span>
              </label>
              <input
                className="form-check-input"
                type="radio"
                name="audioQuality"
                id="mediumRadio"
                value="medium"
                checked={selectedQuality === "medium"}
                // onChange={handleQualityChange}
              />
            </div>
          </div>
          <div className={`vr-set-option ${selectedQuality === "high" ? 'is-selected' : ''}`}
            role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
            onClick={(e) => handleQualityChange('high', e)}>
            <div className="form-check">
              <span className="vr-set-option-icon"><Icon icon="lucide:signal-high" width="18" height="18" /></span>
              <label className="form-check-label" htmlFor="highRadio">
                <span className="vr-set-option-title">
                  High
                  <p className="vr-set-option-desc">
                    Smoother and higher quality
                  </p>
                </span>
              </label>
              <input
                className="form-check-input"
                type="radio"
                name="audioQuality"
                id="highRadio"
                value="high"
                checked={selectedQuality === "high"}
              />
            </div>
          </div>
        </div>
        <div className="form-group vr-set-actions">
          <button
            type="submit"
            className="vr-btn vr-btn-primary vr-btn-lg"
            disabled={loading || user?.audioQuality === selectedQuality}
            style={{ cursor: loading || user?.audioQuality === selectedQuality ? 'not-allowed' : 'pointer' }}
            onClick={(e) => {
              if (!loading) {
                handleQualityUpdate(e);
              }

            }}
          >

            {loading ? (
              <>
                <span style={{ marginRight: '10px' }}>Loging in</span>

                <div
                  className="spinner-border vr-set-spin"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </>
            ) : (
              <>
                <span>
                  Save
                </span>
              </>
            )
            }
          </button>
        </div>
      </div>
    </div>
  )
}

export default RecordingQuality
